<template>
    <div>
        <!-- <div v-if="props.column.field == 'checkbox'">
            <v-checkbox />
        </div> -->
        <span v-if="props.column.field == 'name'">
            <!-- {{ props.row }} -->
            {{ props.row.name }}
        </span>
        <span v-if="props.column.field == 'status'" class="d-flex">
            <toggle-button @change="$emit('editToggle', props.row)"
                :disabled="props.row._id == '65fd2e74004c9c0defa3846d' ? true : false" sync
                v-model='props.row.status' />
        </span>
        <span v-if="props.column.field == 'member'" class="d-flex">
            {{ combine(props.row.memberNames) }}
        </span>
        <span v-if="props.column.field == 'action'" class="d-flex">
            <b-dropdown variant="black" toggle-class="text-decoration-none p-0 " no-caret>
                <template #button-content>
                    <i class="icon-more-alt rounded-circle p-2 action"></i>
                </template>
                <b-dropdown-item @click="$emit('editRow', props.row)" v-b-modal.addqueue>
                    <feather class="mr-1" style="width: 14px;" type="edit" /> <span class='ml-1'>Edit</span>
                </b-dropdown-item>
                <b-dropdown-item v-if="props.row._id != '65fd2e74004c9c0defa3846d'"
                    @click="$emit('deleteRow', props.row)"><font-awesome-icon icon="fa-solid fa-trash" />
                    <span class='ml-1'>
                        Delete
                    </span>
                </b-dropdown-item>
            </b-dropdown>
        </span>
    </div>
</template>
<script>
export default ({
    name: 'datatable-row-default',
    props: {
        props: Object,
        data: Object,
        isShowSelect: Boolean,
    },
    data() {
        return {
        }
    },
    mounted() {
    },
    methods: {
        combine(mem) {
            if (mem == null) {
                return '-'
            } else {
                mem = mem.map(item => item.replace(":", " ")).join(", ");
                return mem;
            }
        }
    }
})
</script>

<style>
/* .topRule {
    opacity: 0.5;
    cursor: not-allowed;
}

.notTopRule {
    opacity: 1;
    cursor: pointer;
} */
</style>
